module.exports = __webpack_public_path__ + "img/theos.96f80271.svg";